import React from 'react';

const LogoutIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none">
      <path
        stroke="#F2F4F7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M20 21.25 26.25 15m0 0L20 8.75M26.25 15h-15m0-11.25h-1.5c-2.1 0-3.15 0-3.952.409a3.75 3.75 0 0 0-1.64 1.639C3.75 6.6 3.75 7.65 3.75 9.75v10.5c0 2.1 0 3.15.409 3.953a3.75 3.75 0 0 0 1.639 1.638c.802.409 1.852.409 3.952.409h1.5"
      />
    </svg>
  );
};

export default LogoutIcon;
